import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";

import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import {
  getSchoolEvent,
  addGuardianToEvent,
} from "../../services/EventService";
import { hasError, getError } from "../../services/ServiceHelper";
import { showError, showSuccess, showToast } from "../../components/ATPDialogs";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import EventDetails from "../../components/faculty/EventDetails";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import isEmpty from "lodash-es/isEmpty";
import { getSubDomain, isValidEmail } from "../../services/StringService";
import { getSchoolBySubdomain } from "../../services/SchoolService";

/**
 *
 * @returns receives the request to process the QR code.  Accepts the encrypted code, then forwards to login page for further processing
 */
const UseEventGuardianQr = () => {
  const [_school, setSchool] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();

  const { eid } = useParams();
  const [_event, setEvent] = useState({ event: {}, members: [] });
  const [_showProgress, setShowProgress] = useState(false);

  const [_email, setEmail] = useState("");
  const [_firstName, setFirstName] = useState("");
  const [_lastName, setLastName] = useState("");
  const [_students, setStudents] = useState("");

  useEffect(() => {
    initEvent();
  }, []);

  const initEvent = () => {
    setShowProgress(true);
    const school = getSchoolBySubdomain(getSubDomain());
    setSchool(school);
    getSchoolEvent(school, _jwt, eid)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to get Event: ", getError(results));
          return;
        }
        setEvent(results.data);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => setShowProgress(false));
  };

  const handleSubmit = () => {
    if (isEmpty(_email)) {
      showError("Unable to Submit", "Please enter Email Address.");
      return;
    }
    if (!isValidEmail(_email)) {
      showError("Unable to Submit", "Please enter Valid Email Address.");
      return;
    }

    setShowProgress(true);
    addGuardianToEvent(
      _school,
      _jwt,
      eid,
      _email,
      _lastName,
      _firstName,
      _students
    )
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to Add Guardian to Event: ",
            getError(results)
          );
          return;
        }

        showSuccess("You have been added! Thanks!");
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
        showError("Unable to Add Guardian to Event", error);
      })
      .finally(() => setShowProgress(false));
  };

  return (
    <Container sx={{ mt: 1 }}>
      <Title text="Event Guardian QR" showBack={true} />
      <ProgressBar showProgress={_showProgress} />

      {_event != null && (
        <EventDetails school={_school} eventDetails={_event.event} />
      )}

      <Alert severity="info" sx={{ mt: 1, mb: 1 }}>
        Enter the information to enroll for this Event.
        <br />
      </Alert>

      <InputLabel sx={{ mt: 1 }}>Email</InputLabel>
      <TextField
        type="text"
        fullWidth
        size="small"
        onChange={(evt) => setEmail(evt.target.value)}
        placeholder="Required Field"
        value={_email}
      />
      <InputLabel sx={{ mt: 1 }}>First Name</InputLabel>
      <TextField
        type="text"
        fullWidth
        size="small"
        onChange={(evt) => setFirstName(evt.target.value)}
        placeholder="Optional Field"
        value={_firstName}
      />
      <InputLabel sx={{ mt: 1 }}>Last Name</InputLabel>
      <TextField
        type="text"
        fullWidth
        size="small"
        onChange={(evt) => setLastName(evt.target.value)}
        placeholder="Optional Field"
        value={_lastName}
      />
      <InputLabel sx={{ mt: 1 }}>Your Students</InputLabel>
      <TextField
        type="text"
        fullWidth
        size="small"
        onChange={(evt) => setStudents(evt.target.value)}
        placeholder="Optional Field"
        value={_students}
      />
      <Button onClick={handleSubmit} sx={{ mt: 2 }} variant="contained">
        Submit
      </Button>
    </Container>
  );
};

export default UseEventGuardianQr;
